import { memo, type ReactNode } from 'react'

import type { DataTableProps } from './data-table.interface'
import { DataTableStateRenderer } from './data-table-state-renderer.molecule'
import { DataTableToolbar } from './data-table-toolbar.molecule'
import { useDataTableState } from './useDataTableState.hook'

/**
 * A flexible and feature-rich data table component.
 * Supports selection, sorting, filtering, pagination, and row actions.
 */
const DataTableInner = <TData,>(props: DataTableProps<TData>): ReactNode => {
  const { p, tableState, hasToolbar, toolbarProps } = useDataTableState(props)
  const toolbar = hasToolbar ? <DataTableToolbar {...toolbarProps} /> : null

  return (
    <DataTableStateRenderer
      isLoading={p.isLoading}
      toolbar={toolbar}
      data={p.data}
      columnList={p.columnList}
      getRowId={p.getRowId}
      isSelectable={p.isSelectable}
      actionList={p.actionList}
      emptyMessage={p.emptyMessage}
      onSortChange={p.onSortChange}
      pagination={p.pagination}
      onPageChange={p.onPageChange}
      onPageSizeChange={p.onPageSizeChange}
      className={p.className}
      tableState={tableState}
    />
  )
}

export const DataTable = memo(DataTableInner) as typeof DataTableInner
